import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
declare var $: any;

@Component({
  selector: "app-product-detail",
  templateUrl: "./product-detail.component.html",
  inputs: ["groupedColors", "item", "isCustomerList", "activeImgIdx"],
  outputs: ["closeThumbnailEvent"]
})
export class ProductDetailComponent implements OnInit {
  constructor() {}

  public topImage = {};
  groupedColors;
  showProductDetailAfterDelay = false;
  public allImages;
  rightArrow = true;
  leftArrow = true;
  allImageDots = false;
  lImg;
  activeImgIdx = 0;

  _value;

  public closeThumbnailEvent = new EventEmitter<string>();
  // public activeGalIdx = new EventEmitter<number>();

  @Input() region;
  @Input() assortment;
  @Input() collection;

  @Input() note;
  @Input() onDisplayBiggerImage;

  @Input() i;
  @Input() j;
  @Input() k;
  @Input() p;

  @Input()
  get colorId() {
    return this._value;
  }
  set colorId(val) {
    this._value = val;
    this.activeImgIdx = 0;
    this.leftArrow = false;
    this.rightArrow = true;
  }

  @Output("notesEvent") onNotesEvent = new EventEmitter();

  closeThumbnail() {
    this.closeThumbnailEvent.emit();
  }

  notesEvent(topImage, m) {
    this.groupedColors[m] = topImage;
    this.onNotesEvent.next({ data: this.groupedColors });
  }

  onRight(images) {
    this.rightArrow = true;
    if (this.activeImgIdx == images.length - 2) {
      this.rightArrow = false;
    }
    if (this.activeImgIdx > -1) {
      this.leftArrow = true;
    }
    this.activeImgIdx = this.activeImgIdx + 1;
    // this.lImg = images[this.activeImgIdx];
    // console.log(this.lImg, images[i]);
  }

  onMovingRight(images, imagesId, m, e) {
    if (e.keyCode == 39) {
      if (this.colorId === imagesId) {
        // console.log(images.length, this.activeImgIdx, "imagesIdm");
        if (this.activeImgIdx == images.length - 1) {
          return;
        }
        this.onRight(images[m]);
        if (this.activeImgIdx == images.length - 1) {
          this.rightArrow = false;
          return;
        }
      }
    }
  }

  onLeft(images) {
    this.leftArrow = true;
    if (this.activeImgIdx == 1) {
      this.leftArrow = false;
    }
    if (this.activeImgIdx - 1 < images.length) {
      this.rightArrow = true;
    }
    this.activeImgIdx = this.activeImgIdx - 1;
  }

  onMovingLeft(images, imagesId, m, e) {
    if (e.keyCode == 37) {
      if (this.colorId === imagesId) {
        this.onLeft(images[m]);
      }
    }
  }

  ngOnInit() {
    // this.activeGalIdx.emit(this.activeImgIdx);
    setTimeout(() => {
      this.showProductDetailAfterDelay = true;
    }, 200);
    setTimeout(() => {
      this.allImageDots = true;
      this.rightArrow = true;
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/products/product-detail/product-detail.component.ts